export default {
  products: [],
  selectedProduct: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/product/state.js